<div class="card-grid" *ngIf="display === 'grid'" #grid>
  <div class="create-section card-grid-item" *ngIf="showCreate && can_edit" (click)="selectHosting()">
    <div fxLayout="column" class="width-100 padding-2" fxLayoutAlign="center center">
      <i class="icon-add width-100 margin-top-2 text-center" *ngIf="!isLoading"></i>
      <uni-loader [radius]="20" *ngIf="isLoading"></uni-loader>
      <ng-container *ngIf="host=== 'organization'; else elseTemplate">
        <p class="font-md sparro-grey-900 font-bold">Launch/list a competition on UNI</p>
        <p class="font-sm sparro-grey-800 text-center">Get started by crowdsourcing your design need on UNI.</p>
      </ng-container>
      <ng-template #elseTemplate>
        <!-- <p class="font-md sparro-grey-900 font-bold">Upload new competition</p>
        <p class="font-sm margin-0 sparro-grey-900">For PDF portfolios, reports, publications</p> -->
      </ng-template>
    </div>
  </div>
  <ng-container *ngIf="competitions?.length > 0">
    <div *ngFor="let competition of competitions" class="card-grid-item" [class.responsive-card-container]="responsiveCards" >
      <uni-competition-card
        class="width-100"
        [competition]="competition"
        [footerType]="footerType"
        [can_edit]="can_edit"
        [can_delete]="can_delete"
        [host]="host">
      </uni-competition-card>
    </div>
  </ng-container>
</div>

<div class="card-grid" id="grid-breakpoint" *ngIf="display === 'breakpoint'" #grid>
  <div *ngFor="let competition of visibleCompetitions" class="card-grid-item" [class.responsive-card-container]="responsiveCards" >
    <uni-competition-card
      class="width-100"
      [competition]="competition"
      [footerType]="footerType"
      [can_edit]="can_edit"
      [can_delete]="can_delete"
      [host]="host">
    </uni-competition-card>
  </div>
</div>
